<script>
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";
import axios from "axios";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {loading, dialog} = useSharedData();
        const {$route, $refs} = useTools();
        const {getBack} = useSharedMethod();
        
        const observation = ref(null);
        
        function gathering() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.post(`/workerBalances/gathering/${$route.params.id}`, observation.value).then(() => {
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        return {
            mxRules,
            loading,
            dialog,
            observation,
            gathering,
            getBack
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500"
        scrollable
    >
        <v-card>
            <w-toolbar color="blue darken-2" :title="$t('balance.type_MANUAL_GATHERING')"/>
            <v-card-text>
                <v-container fluid>
                    <v-form lazy-validation ref="form">
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('common.comment')" required/>
                                <w-simple-text-area
                                    v-model="observation"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    color="blue darken-2"
                    icon="mdi-sigma"
                    :text="$t('balance.type_MANUAL_GATHERING')"
                    :loading="loading"
                    @press="gathering"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>